module.exports = __webpack_public_path__ + "static/media/Icon_Pfeil.527487e1.png";